import { BellSimple } from 'phosphor-icons';
import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Counter } from '../../atoms/Counter';
import { NotificationTriggerProps } from './NotificationTrigger.types';

export const NotificationTrigger = ({
  counter,
  microcopy,
  className = '',
  ...buttonProps
}: NotificationTriggerProps) => {
  return (
    <span className={c('relative inline-flex', className)}>
      <button
        type="button"
        aria-label={microcopy.buttonAriaLabel}
        className="rounded-full p-2 hover:bg-grey-700 focus:outline-none focus:ring-2 focus:ring-blue-hover active:bg-grey-700"
        {...buttonProps}
      >
        <BellSimple className="h-5 w-5 text-white" />
      </button>
      {counter !== undefined && (
        <Counter
          className="pointer-events-none absolute left-1/2 top-2 min-w-[18px] -translate-y-1/2"
          counter={counter}
          ariaLabel={interpolateStringWithData(microcopy.unreadCountAriaLabel, {
            count: counter,
          })}
        />
      )}
    </span>
  );
};
